import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Mounts one surface's material: inside a GeometryInstance3D drawer, its unfaded and alpha-pass
 * pair, which the instance's fade swaps before each render, and elsewhere the unfaded one alone.
 */
import { Fragment } from 'react';
import { useSwappedMaterials } from './swappedMaterials';
export function FadedMaterials({ attach, children }) {
    const swapped = useSwappedMaterials(attach);
    if (!swapped)
        return children('unfaded', attach);
    // Keyed on `attach` too: it names the draw group the function attaches swap.
    return (_jsxs(_Fragment, { children: [_jsx(Fragment, { children: children('unfaded', swapped.unfaded) }, `unfaded:${attach}`), _jsx(Fragment, { children: children('alphaPass', swapped.alphaPass) }, `alphaPass:${attach}`)] }));
}
//# sourceMappingURL=FadedMaterials.js.map